import Debug from "debug";

import { ACTIONS } from "./constants";
import {
  ActionLoading,
  ActionChannel,
  Stream,
  ActionError,
  EditorError,
} from "../types";

const debug = Debug("broadcast:actions:editor");

export const setLoading = (payload: boolean): ActionLoading => {
  debug("setLoading", payload);
  return {
    type: ACTIONS.EDITOR_LOADING_STATE,
    payload,
  };
};

export const configChannelPresent = (payload: boolean): ActionLoading => {
  debug("configChannelPresent", payload);
  return {
    type: ACTIONS.EDITOR_CONFIG_CHANNEL_PRESENT,
    payload,
  };
};

export const selectChannel = (payload: Stream): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_SELECT_CHANNEL,
    payload,
  };
};

export const deselectChannel = (payload: null): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_DESELECT_CHANNEL,
    payload,
  };
};

export const startDelete = (payload: Stream): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_DELETE_WARNING_MODAL_SHOW,
    payload,
  };
};

export const endDelete = (payload: Stream | null): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_DELETE_WARNING_MODAL_HIDE,
    payload,
  };
};

export const startRename = (payload: Stream): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_RENAME_MODAL_SHOW,
    payload,
  };
};

export const endRename = (payload: Stream | null): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_RENAME_MODAL_HIDE,
    payload,
  };
};

export const startCreate = (): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_CREATE_MODAL_SHOW,
    payload: null,
  };
};

export const endCreate = (): ActionChannel => {
  return {
    type: ACTIONS.EDITOR_CREATE_MODAL_HIDE,
    payload: null,
  };
};

export const removeError = (payload: EditorError): ActionError => {
  return {
    type: ACTIONS.EDITOR_REMOVE_ERROR,
    payload,
  };
};
